import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemData {
  title: string;
  content: string;
  image?: string;
}
interface AccordionItemProps extends AccordionItemData {
  isOpen: boolean;
  onClick: () => void;
}
export function AccordionItem({
  title,
  content,
  image,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-sky-100 rounded-xl mb-3 overflow-hidden bg-white shadow-sm" data-id="element-111">
      {image && <div className="relative bg-slate-100" data-id="element-112">
          <img src={image} alt={title} className="w-full h-36 object-cover object-top" data-id="element-113" />
          {/* Degrade / fade preview overlay */}
          <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-white via-white/70 to-transparent" data-id="element-114" />
          <span className="absolute top-2 left-2 bg-sky-600 text-white text-[10px] font-black px-2 py-1 rounded-md uppercase tracking-wider shadow-sm" data-id="element-115">
            Vista previa
          </span>
        </div>}
      <button className={`w-full px-4 ${image ? 'py-3' : 'py-4'} text-left flex justify-between items-center bg-white hover:bg-sky-50 transition-colors`} onClick={onClick} data-id="element-116">
        <span className="font-semibold text-slate-800 pr-4" data-id="element-117">{title}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-sky-500 flex-shrink-0" data-id="element-118" /> : <ChevronDown className="w-5 h-5 text-sky-500 flex-shrink-0" data-id="element-119" />}
      </button>
      {isOpen && <div className="px-4 py-3 bg-sky-50/50 text-slate-600 text-sm leading-relaxed border-t border-sky-100" data-id="element-120">
          {content}
        </div>}
    </div>;
}
export function Accordion({
  items
}: {
  items: AccordionItemData[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full" data-id="element-121">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} content={item.content} image={item.image} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-122" />)}
    </div>;
}